import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Toast from 'react-bootstrap/Toast';

export default (props) => {
  const { autoHide = true, width } = props;
  return (
    <Row
      style={{
        margin: 0,
        position: 'fixed',
        zIndex: 999999999999,
        width: '100%',
        top: 81,
        right: 0,
      }}
    >
      <Col xs={12} sm={12} md={6}>
        <Toast
          style={{ maxWidth: width ?? 350 }}
          className={props.error ? 'bg-danger' : 'bg-success'}
          onClose={props.closeToast}
          show={props.show}
          delay={3000}
          autohide={autoHide}
        >
          <Toast.Header
            style={{
              borderBottom: 'none',
              display: 'block',
              paddingTop: 0,
              paddingBottom: 0,
              color: '#fff',
            }}
          />
          <Toast.Body
            className={props.error ? 'bg-danger' : 'bg-success'}
            style={{
              display: 'flex',
              paddingTop: 20,
              paddingBottom: 25,
              color: '#fff',
            }}
          >
            {props.message}
          </Toast.Body>
        </Toast>
      </Col>
    </Row>
  );
};
